export class DeleteUser {
  public static readonly type = "[Users] Delete User";
  public constructor(public id: string) {}
}
